import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import cloneDeep from 'lodash-es/cloneDeep';
import { RoleModalComponent, RoleUsersModalComponent, } from './modals';
var ɵ0 = urlStateHandler;
var RolesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RolesPageComponent, _super);
    function RolesPageComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RolesPageComponent.prototype.openModal = function (model) {
        var _this = this;
        var clone;
        if (model) {
            clone = cloneDeep(model);
        }
        this._modal
            .openModal(RoleModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (res) {
            switch (res.type) {
                case 1 /* Add */:
                    // open the manage users modal
                    _this.openUsersModal(res.data);
                    _this._refresh$.next();
                    break;
                case 2 /* Update */:
                    _this._refresh$.next();
                    break;
            }
        });
    };
    RolesPageComponent.prototype.openUsersModal = function (model) {
        var clone = cloneDeep(model);
        this._modal.openModal(RoleUsersModalComponent, clone);
    };
    RolesPageComponent.prototype.ngOnInit = function () {
        this._expand$.next(['Permissions']);
    };
    Object.defineProperty(RolesPageComponent.prototype, "allowDelete", {
        get: function () {
            return this._grid.selectionManager.hasValue() &&
                this._grid.selectionManager.selected.every(function (r) { return r.isStatic === false; });
        },
        enumerable: true,
        configurable: true
    });
    return RolesPageComponent;
}(ODataGridComponent));
export { RolesPageComponent };
export { ɵ0 };
